export default {
  modifyAlternativeName: 'Modify alternative name.',
  replaceAlternativeName: 'Replace alternative name.',
}
